module.exports = fs;


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 258
// module chunks = 4